import React from "react";


export default function ListModal({ open, list, onClose, onChoose }) {
    if (!open || !list) return null;
    return (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/30 backdrop-blur-sm" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 p-6 space-y-4" onClick={(e) => e.stopPropagation()}>
                <h2 className="text-lg font-semibold">{list.prompt}</h2>
                <ul className="divide-y">
                    {list.options.map((row) => (
                    <li key={row.id} className="py-3 cursor-pointer hover:bg-gray-50" onClick={() => onChoose(row)}>
                        <div className="font-medium">{row.title}</div>
                        {row.description && <p className="text-sm text-gray-500">{row.description}</p>}
                    </li>
                    ))}
                </ul>
                <button onClick={onClose} className="btn btn-outline-primary w-full mt-2">
                    Cancelar
                </button>
            </div>
        </div>
    );
}
